// Base de Dados de Modelos de Landing Pages - Suzume Technologies

export const CATEGORIES = [
  { id: 'todos', label: 'Todos os Nichos' },
  { id: 'artesanato', label: 'Artesanato & Handcrafted' },
  { id: 'mecanica', label: 'Mecânica & Automotivo' },
  { id: 'saude', label: 'Saúde & Bem-Estar' },
  { id: 'gastronomia', label: 'Gastronomia & Confeitaria' },
  { id: 'advocacia', label: 'Advocacia & Direito' },
  { id: 'beleza', label: 'Beleza & Estética' },
  { id: 'arquitetura', label: 'Arquitetura & Construção' },
  { id: 'educacao', label: 'Educação & Cursos' },
  { id: 'imobiliaria', label: 'Imobiliária & Corretagem' },
  { id: 'pet', label: 'Pet Shop & Veterinária' },
  { id: 'fitness', label: 'Fitness & Personal' },
  { id: 'eventos', label: 'Eventos & Fotografia' }
];

export const MODELS_DATA = [
  {
    id: 'art-01',
    name: 'Amigurumi & Mimos Criativos',
    category: 'Artesanato & Handcrafted',
    categorySlug: 'artesanato',
    description: 'Landing page delicada e acolhedora projetada para artesãos de crochê, amigurumi e trabalhos manuais sob encomenda.',
    tags: ['Catálogo Visual', 'Pedido via WhatsApp', 'Depoimentos', 'Galeria HD'],
    rating: 4.9,
    reviewsCount: 38,
    isPopular: true,
    accentColor: '#ec4899',
    gradient: 'linear-gradient(135deg, #fbcfe8 0%, #f472b6 50%, #db2777 100%)',
    features: ['Galeria estilo Pinterest com zoom', 'Calculadora rápida de orçamento', 'Botões diretos para WhatsApp de pedidos', 'Seção de tabela de prazos e cuidados']
  },
  {
    id: 'mec-01',
    name: 'AutoFix Mecânica Especializada',
    category: 'Mecânica & Automotivo',
    categorySlug: 'mecanica',
    description: 'Design robusto e de alta conversão focado em oficinas mecânicas, centros automotivos, troca de óleo e auto elétricas.',
    tags: ['Agendamento Online', 'Tabela de Serviços', 'Localização GPS', 'Selos de Garantia'],
    rating: 4.8,
    reviewsCount: 45,
    isPopular: true,
    accentColor: '#f97316',
    gradient: 'linear-gradient(135deg, #ffedd5 0%, #fb923c 50%, #ea580c 100%)',
    features: ['Formulário rápido de pré-agendamento', 'Listagem clara de serviços (Motor, Freios, Ar-condicionado)', 'Integração direta com Google Maps e Waze', 'Banner de atendimento emergencial']
  },
  {
    id: 'sau-01',
    name: 'Clínica Vida & Odontologia Prime',
    category: 'Saúde & Bem-Estar',
    categorySlug: 'saude',
    description: 'Página ultra limpa e corporativa para dentistas, clínicas médicas, dermatologistas e profissionais de saúde.',
    tags: ['Corpo Clínico', 'Convênios Aceitos', 'WhatsApp Rápido', 'Design Clean'],
    rating: 5.0,
    reviewsCount: 62,
    isPopular: true,
    accentColor: '#0284c7',
    gradient: 'linear-gradient(135deg, #e0f2fe 0%, #38bdf8 50%, #0284c7 100%)',
    features: ['Apresentação dos especialistas com registro profissional', 'Exibição dos convênios de saúde aceitos', 'Botão flutuante de agendamento de consultas', 'Perguntas frequentes pré-consulta']
  },
  {
    id: 'gas-01',
    name: 'Bistrô & Confeitaria Gourmet',
    category: 'Gastronomia & Confeitaria',
    categorySlug: 'gastronomia',
    description: 'Visual apetitoso e moderno perfeito para restaurantes, confeitarias artesanais, hamburguerias e buffets.',
    tags: ['Cardápio Digital', 'Horário de Funcionamento', 'Pedidos Direct', 'Instagram Feed'],
    rating: 4.9,
    reviewsCount: 51,
    isPopular: false,
    accentColor: '#eab308',
    gradient: 'linear-gradient(135deg, #fef08a 0%, #facc15 50%, #ca8a04 100%)',
    features: ['Cardápio digital responsivo categorizado', 'Destaque para pratos e bolos mais vendidos', 'Link para iFood e WhatsApp de entregas', 'Avaliações reais do Google Meu Negócio']
  },
  {
    id: 'adv-01',
    name: 'Vanguard Advocacia & Direito',
    category: 'Advocacia & Direito',
    categorySlug: 'advocacia',
    description: 'Estilo sóbrio, luxuoso e corporativo ideal para escritórios de advocacia, consultores jurídicos e pareceristas.',
    tags: ['Áreas de Atuação', 'Consulta Inicial', 'Segurança LGPD', 'Formulário Seguro'],
    rating: 5.0,
    reviewsCount: 29,
    isPopular: true,
    accentColor: '#1e293b',
    gradient: 'linear-gradient(135deg, #334155 0%, #1e293b 50%, #0f172a 100%)',
    features: ['Apresentação refinada das áreas do Direito', 'Formulário sigiloso de triagem de casos', 'Perfil dos advogados sócios e OAB', 'Artigos e informativos jurídicos recentes']
  },
  {
    id: 'bel-01',
    name: 'Glow Studio & Barbearia VIP',
    category: 'Beleza & Estética',
    categorySlug: 'beleza',
    description: 'Design sofisticado e vibrante para salões de beleza, clínicas de estética, barbearias premium e spas.',
    tags: ['Tabela de Preços', 'Agendamento Fácil', 'Galeria Antes & Depois', 'Combos Promocionais'],
    rating: 4.9,
    reviewsCount: 41,
    isPopular: true,
    accentColor: '#8b5cf6',
    gradient: 'linear-gradient(135deg, #ddd6fe 0%, #a78bfa 50%, #7c3aed 100%)',
    features: ['Galeria comparativa Antes/Depois com slider', 'Pacotes de assinaturas e dia da noiva', 'Agendamento integrado de horários', 'Avaliações com nota 5 estrelas']
  },
  {
    id: 'arq-01',
    name: 'BuildPro Arquitetura & Obras',
    category: 'Arquitetura & Construção',
    categorySlug: 'arquitetura',
    description: 'Portfolio de arquitetura e projetos de engenharia civil com layout imersivo e elegante.',
    tags: ['Portfólio 3D', 'Solicitação de Projeto', 'Metodologia', 'Projetos Executados'],
    rating: 4.8,
    reviewsCount: 23,
    isPopular: false,
    accentColor: '#64748b',
    gradient: 'linear-gradient(135deg, #cbd5e1 0%, #64748b 50%, #334155 100%)',
    features: ['Exibição interativa de plantas e renderizações 3D', 'Linha do tempo das etapas do projeto', 'Briefing inicial dinâmico para orçamento', 'Lista de parceiros e fornecedores']
  },
  {
    id: 'edu-01',
    name: 'AprendaMais Cursos & Mentoria',
    category: 'Educação & Cursos',
    categorySlug: 'educacao',
    description: 'Landing page de alta conversão para professores particulares, mentores digitais, e-books e cursos livres.',
    tags: ['Grade Curricular', 'Garantia 7 Dias', 'Inscrição Direta', 'Bônus Exclusivos'],
    rating: 4.9,
    reviewsCount: 77,
    isPopular: true,
    accentColor: '#10b981',
    gradient: 'linear-gradient(135deg, #a7f3d0 0%, #34d399 50%, #059669 100%)',
    features: ['Cronômetro de oferta por tempo limitado', 'Módulos detalhados do treinamento', 'Selo de certificado e garantia incondicional', 'FAQ com dúvidas sobre a plataforma']
  },
  {
    id: 'imo-01',
    name: 'Prime Imóveis & Alto Padrão',
    category: 'Imobiliária & Corretagem',
    categorySlug: 'imobiliaria',
    description: 'Visual de prestígio para corretores autônomos, imobiliárias de bairro e lançamentos residenciais.',
    tags: ['Filtro de Imóveis', 'Calculadora Financiamento', 'Visita Agendada', 'Fotos 4K'],
    rating: 4.7,
    reviewsCount: 34,
    isPopular: false,
    accentColor: '#0f766e',
    gradient: 'linear-gradient(135deg, #99f6e4 0%, #2dd4bf 50%, #0d9488 100%)',
    features: ['Card de destaques de casas e apartamentos', 'Calculadora estimativa de parcelamento', 'Formulário rápido para proprietários anunciarem', 'Chat rápido de corretor no plantão']
  },
  {
    id: 'pet-01',
    name: 'VetCare Pet Shop & Clínica',
    category: 'Pet Shop & Veterinária',
    categorySlug: 'pet',
    description: 'Página alegre e confiável para hospitais veterinários, pet shops, banho & tosa e adestradores.',
    tags: ['Planos de Saúde Pet', 'Leva e Traz', 'Atendimento 24h', 'Galeria Fofura'],
    rating: 5.0,
    reviewsCount: 56,
    isPopular: false,
    accentColor: '#f43f5e',
    gradient: 'linear-gradient(135deg, #fecdd3 0%, #fb7185 50%, #e11d48 100%)',
    features: ['Callout de urgência e emergência 24 horas', 'Tabela de serviços de estética e vacinação', 'Depoimentos de tutores com fotos de pets', 'Mapa de rota fácil para a clínica']
  },
  {
    id: 'fit-01',
    name: 'PeakFitness Studio & Personal',
    category: 'Fitness & Personal',
    categorySlug: 'fitness',
    description: 'Layout moderno e motivacional para academias de bairro, studios de pilates, crossfit e personal trainers.',
    tags: ['Passes Experimentais', 'Planos de Treino', 'Transformações', 'Horários de Aulas'],
    rating: 4.8,
    reviewsCount: 49,
    isPopular: false,
    accentColor: '#dc2626',
    gradient: 'linear-gradient(135deg, #fca5a5 0%, #ef4444 50%, #b91c1c 100%)',
    features: ['Reserva de aula experimental grátis', 'Quadro de horários e modalidades oferecidas', 'Área de bioimpedância e acompanhamento', 'Galeria de fotos do espaço físico']
  },
  {
    id: 'eve-01',
    name: 'Lumiera Eventos & Foto Studio',
    category: 'Eventos & Fotografia',
    categorySlug: 'eventos',
    description: 'Galeria fotográfica de alto nível para fotógrafos de casamento, festas corporativas e produtores de evento.',
    tags: ['Portfólio Fotográfico', 'Solicitar Orçamento', 'Packs de Cobertura', 'Vídeo Highlights'],
    rating: 4.9,
    reviewsCount: 31,
    isPopular: false,
    accentColor: '#d97706',
    gradient: 'linear-gradient(135deg, #fde68a 0%, #f59e0b 50%, #d97706 100%)',
    features: ['Galeria masonry de alta definição', 'Formulário com data do evento e localização', 'Depoimentos emocionantes de noivos e clientes', 'Exibição de premiações e publicações']
  },
  {
    id: 'art-02',
    name: 'Ateliê Costura & Bordado Fino',
    category: 'Artesanato & Handcrafted',
    categorySlug: 'artesanato',
    description: 'Modelo gracioso para costureiras, bordadeiras e ateliês de peças sob medida e vestidos exclusivos.',
    tags: ['Sob Medida', 'Ajustes Rápidos', 'Galeria de Peças', 'Catálogo Tecidos'],
    rating: 4.9,
    reviewsCount: 27,
    isPopular: false,
    accentColor: '#db2777',
    gradient: 'linear-gradient(135deg, #f472b6 0%, #db2777 50%, #9d174d 100%)',
    features: ['Catálogo interativo de estampas e tecidos', 'Tabela explicativa das provas e medidas', 'Atendimento direto via WhatsApp', 'Selo de garantia de acabamento perfeito']
  },
  {
    id: 'mec-02',
    name: 'MotoExtreme Oficina de Motos',
    category: 'Mecânica & Automotivo',
    categorySlug: 'mecanica',
    description: 'Design dinâmico focado em revisão de motocicletas de alta cilindrada, troca de pneus e customização.',
    tags: ['Peças Originais', 'Guincho 24h', 'Orçamento Instantâneo', 'Motos Premium'],
    rating: 4.8,
    reviewsCount: 33,
    isPopular: false,
    accentColor: '#ea580c',
    gradient: 'linear-gradient(135deg, #fed7aa 0%, #f97316 50%, #c2410c 100%)',
    features: ['Solicitação de resgate/guincho pelo WhatsApp', 'Listagem de marcas atendidas (Honda, Yamaha, BMW)', 'Galeria de projetos de customização', 'Depoimentos de motociclistas']
  },
  {
    id: 'sau-02',
    name: 'Espaço Natura Fisioterapia & SPA',
    category: 'Saúde & Bem-Estar',
    categorySlug: 'saude',
    description: 'Página relaxante e intuitiva para fisioterapeutas, osteopatas e massoterapeutas.',
    tags: ['Tratamentos Dor', 'Fisioterapia Esportiva', 'Agende Sessão', 'Ambiente Climatizado'],
    rating: 5.0,
    reviewsCount: 44,
    isPopular: false,
    accentColor: '#059669',
    gradient: 'linear-gradient(135deg, #6ee7b7 0%, #10b981 50%, #047857 100%)',
    features: ['Explicação visual dos métodos de tratamento', 'Formulário de sintomatologia prévia', 'Combos de pacotes de sessões com desconto', 'Avaliações com nota máxima de pacientes']
  }
];

// Função helper para sortear N itens aleatórios sem repetição
export function getRandomModels(count = 6) {
  const shuffled = [...MODELS_DATA].sort(() => 0.5 - Math.random());
  return shuffled.slice(0, count);
}
